import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import Guide from "@/pages/Guide";
import Register from "@/pages/Register";
import Exploradores from "@/pages/Exploradores";
import Classes from "@/pages/Classes";
import Formulario from "@/pages/Formulario";
import Academy from "@/pages/Academy";
import Event from "@/pages/Event";
import PrivateSessions from "@/pages/PrivateSessions";
import Followup from "@/pages/Followup";
import Mesa from "@/pages/Mesa";
import Series from "@/pages/Series";
import Club from "@/pages/Club";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/admin" element={<Admin />} />
      <Route path="/guide" element={<Guide />} />
      <Route path="/register" element={<Register />} />
      <Route path="/exploradores" element={<Exploradores />} />
      <Route path="/classes" element={<Classes />} />
      <Route path="/formulario-web" element={<Formulario />} />
      <Route path="/create-connect" element={<Event />} />
      <Route path="/private-sessions" element={<PrivateSessions />} />
      <Route path="/evaluacion-rodriguez" element={<Followup />} />
      <Route path="/la-mesa-emprendedora" element={<Mesa />} />
      <Route path="/spanish-through-play" element={<Series />} />
      <Route path="/conversation-club" element={<Club />} />
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/about" element={<Layout><About /></Layout>} />
      <Route path="/services" element={<Layout><Services /></Layout>} />
      <Route path="/business-academy" element={<Layout><Academy /></Layout>} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
